import {Component, Inject} from '@angular/core';
import {BlockForm, BlockTypeEnum, FieldConfigName} from '../../../models';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ConditionBlockDemat} from "app/demat/common/components/form/models/blockdemat.model";

@Component({
  selector: 'app-dm-block-modal',
  templateUrl: './dm-block-modal.component.html',
  styleUrls: ['./dm-block-modal.component.scss']
})
export class DmBlockModalComponent {
  item: BlockForm;
  administratifBlockExist = false;
  confirmButtonText = 'Yes';
  cancelButtonText = 'Cancel';
  readonly titreMaxLen = 80; // NAME_FIELD_SIZE
  readonly descriptionMaxLen = 250; // DESCRIPTION_FIELD_SIZE
  isPublicBlock: boolean;

  conditionDefaultBloc: ConditionBlockDemat = {
    condition: "",
    satisfy: "",
    other: "",
    is_active: false,
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<DmBlockModalComponent>) {
    if (data) {
      this.item = data.form || this.item;
      this.isPublicBlock = (<BlockForm>this.item).type === BlockTypeEnum.Public;
      this.administratifBlockExist = data.administratifBlockExist;
      if (data.buttonText) {
        this.confirmButtonText = data.buttonText.ok || this.confirmButtonText;
      }
    }
    this.item.condition_obj = this.item.condition_obj || this.conditionDefaultBloc;
  }

  onCloseClick(): void {
    this.dialogRef.close(true);
  }

  mapFieldOnChangeTypeBlock(): void {
    this.item.fields = this.item.fields
      .map((f: FieldConfigName) => {
        f.isInBlockAdmin = !this.isPublicBlock;
        return f;
      });
  }

  onChangeBlock(): void {
    (<BlockForm>this.item).type = (this.isPublicBlock ? BlockTypeEnum.Public : BlockTypeEnum.Administratif);
    this.administratifBlockExist = !this.isPublicBlock;
    this.mapFieldOnChangeTypeBlock();
  }

  onChangeCondBlock() {
    if (!this.item.condition_obj.is_active) {
      this.item.condition_obj.condition = "";
      this.item.condition_obj.satisfy = "";
      this.item.condition_obj.other = "";
    }
  }
}
